<template>
  <section class="features-section">
    <b-container class="position-relative">
      <b-row>
        <b-col sm="12">
          <h4 class="title-features text-center">{{$t('title_features')}}</h4>
        </b-col>
        <b-col sm="12" md="6">
          <div class="features-content-container">
            <h4 class="features-content-title">{{$t('features_content_title_1')}}</h4>
            <p class="features-content-text">{{$t('features_content_text_1')}}</p>
          </div>
        </b-col>
        <b-col sm="12" md="6">
          <div class="features-content-img">
            <img v-if="$i18n.locale === 'en'" src="../assets/img/features-content-img-1-en.png" alt="Features image">
            <img v-else-if="$i18n.locale === 'uk'" src="../assets/img/features-content-img-1-ua.png" alt="Features image">
            <img  v-else class="grexy-game-image" src="../assets/img/features-content-img-1-en.png" alt="Features image">
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12" md="6"  order="2" order-md="1">
          <div class="features-content-img">
            <img v-if="$i18n.locale === 'en'" src="../assets/img/features-content-img-2-en.png" alt="Features image">
            <img v-else-if="$i18n.locale === 'uk'" src="../assets/img/features-content-img-2-ua.png" alt="Features image">
            <img  v-else class="grexy-game-image" src="../assets/img/features-content-img-2-en.png" alt="Features image">
          </div>
        </b-col>
        <b-col sm="12" md="6" order="1" order-md="2">
          <div class="features-content-container">
            <h4 class="features-content-title">{{$t('features_content_title_2')}}</h4>
            <p class="features-content-text">{{$t('features_content_text_2')}}</p>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12" md="6">
          <div class="features-content-container">
            <h4 class="features-content-title">{{$t('features_content_title_3')}}</h4>
            <p class="features-content-text">{{$t('features_content_text_3')}}</p>
          </div>
        </b-col>
        <b-col sm="12" md="6">
          <div class="features-content-img">
            <img v-if="$i18n.locale === 'en'" src="../assets/img/features-content-img-3-en.png" alt="Features image">
            <img v-else-if="$i18n.locale === 'uk'" src="../assets/img/features-content-img-3-ua.png" alt="Features image">
            <img  v-else class="grexy-game-image" src="../assets/img/features-content-img-3-en.png" alt="Features image">
          </div>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>
<script>
export default {
  data () {
    return {
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/assets/sass/app.scss";
.features-section{
  padding: 80px 0;
  background: #ffffff;
  .title-features{
    color: #30394B;
    font-family: $main-font;
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 48px;
    margin: 0 0 40px 0;
    @media screen and (min-width: 320px) {
      margin-bottom: 40px;
      font-size: 40px;
    }
    @media screen and (min-width: 768px) {
      font-size: 32px;
    }
    @media screen and (min-width: 992px) {

    }
    @media screen and (min-width: 1440px) {
      font-size: 48px;

    }
    @media screen and (min-width: 1920px) {

    }
  }
  .features-content-container{
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    .features-content-title{
      color: #30394B;
      font-family: $main-font;
      font-size: 24px;
      font-style: normal;
      font-weight: 700;
      line-height: 28.8px;
      margin: 0 0 24px 0;
    }
    .features-content-text{
      color: #30394B;
      font-family: $main-font;
      font-size: 18px;
      font-style: normal;
      font-weight: 300;
      line-height: 25.2px;
      margin: 0;
      @media screen and (min-width: 320px) {
        font-size: 16px;
        margin-bottom: 32px;
      }
      @media screen and (min-width: 768px) {
        font-size: 14px;
        margin-bottom: 0;
      }
      @media screen and (min-width: 992px) {
        font-size: 18px;
      }
      @media screen and (min-width: 1440px) {
      }
      @media screen and (min-width: 1920px) {
      }
    }
  }
  .features-content-img {
    display: flex;
    justify-content: center;
    align-items: center;
    img{
      width: 100%;
      height: auto;
      @media screen and (min-width: 320px) {
        max-width: 327px;
      }
      @media screen and (min-width: 768px) {
        max-width: 340px;
      }
      @media screen and (min-width: 992px) {
        max-width: 520px;
      }
      @media screen and (min-width: 1440px) {
        max-width: 600px;
      }
      @media screen and (min-width: 1920px) {
      }
    }
  }
}
</style>
